import i18n from '@/lang/i18n'
import buildIconHeaderTemplate from '@/grid/buildIconHeaderTemplate'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { ModuleOperationGuard } from '@/api/operations/guards/module-operation-guard'

export default function() {
    let columns = [
        {
            type: 'text',
            headerName: i18n.t('diagnosis.grid.subportionGrid.subportionLabel'),
            colId: 'label',
            field: 'label',
            width: 170,
            suppressSizeToFit: true
        },
        {
            type: 'text',
            headerName: i18n.t('diagnosis.grid.subportionGrid.assay'),
            suppressSizeToFit: true,
            width: 140,
            colId: 'assay.name',
            field: 'assay.name'
        },
        {
            type: 'text',
            headerName: i18n.t('diagnosis.grid.subportionGrid.requester'),
            suppressSizeToFit: true,
            width: 200,
            colId: 'requester.fullName',
            field: 'requester.fullName'
        },
        {
            type: 'text',
            headerName: i18n.t('diagnosis.grid.subportionGrid.reviewed'),
            suppressSizeToFit: true,
            width: 100,
            colId: 'subportionReview',
            field: 'subportionReview'
        },
        {
            type: 'dateTime',
            headerName: i18n.t('diagnosis.grid.subportionGrid.reviewDate'),
            suppressSizeToFit: true,
            colId: 'subportionReviewDate',
            field: 'subportionReviewDate'
        },
        {
            type: 'text',
            headerName: i18n.t('diagnosis.grid.subportionGrid.valueUnit'),
            suppressSizeToFit: true,
            width: 100,
            colId: 'urv',
            field: 'urv'
        },
        {
            type: 'text',
            headerName: i18n.t('diagnosis.grid.subportionGrid.workUnit'),
            suppressSizeToFit: true,
            width: 100,
            colId: 'ucl',
            field: 'ucl'
        },
        {
            type: 'text',
            headerName: i18n.t('diagnosis.grid.subportionGrid.incidents'),
            headerTooltip: i18n.t('diagnosis.grid.subportionGrid.incidents'),
            suppressSizeToFit: true,
            width: 60,
            colId: 'incidentsCount',
            field: 'incidentsCount',
            filter: false,
            headerComponentParams: {
                template: buildIconHeaderTemplate('far fa-exclamation-triangle')
            }
        },
        {
            type: 'text',
            headerName: i18n.t('diagnosis.grid.subportionGrid.attachments'),
            headerTooltip: i18n.t('diagnosis.grid.subportionGrid.attachments'),
            suppressSizeToFit: true,
            width: 60,
            colId: 'attachmentsCount',
            field: 'attachmentsCount',
            filter: false,
            headerComponentParams: {
                template: buildIconHeaderTemplate('far fa-paperclip')
            }
        }
    ]

    if (ModuleOperationGuard.canAccessBilling) {
        columns.push({
            type: AgGridColumnType.HAS_UNAUTHORIZED_BILLABLE_CONCEPTS,
            field: 'hasUnauthorizedBillableConcepts',
            flex: 1,
            minWidth: 55
        })
    }

    return columns
}
